module.exports = require("@wordpress/core-data");